import { render, staticRenderFns } from "./addedit-mitigatingbarrier.vue?vue&type=template&id=5231bbf2"
import script from "./addedit-mitigatingbarrier.vue?vue&type=script&lang=js"
export * from "./addedit-mitigatingbarrier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports